export enum CalcularHonorarioCredor {
  Sim = 0,
  Nao = 1
}

export const CalcularHonorarioCredorLabel = new Map<CalcularHonorarioCredor, string>([
  [CalcularHonorarioCredor.Sim, "Sim"],
  [CalcularHonorarioCredor.Nao, "Nao"],
]);
